// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q3-9";
export var arrowButtonContainer = "_q3-5";
export var arrowButtonIcon = "_q3-6";
export var carouselArrowButton = "_q3-2";
export var carouselElementContainer = "_q3-1";
export var currentSlide = "_q3-8";
export var left = "_q3-3";
export var otherSlide = "_q3-a";
export var productCarouselContainer = "_q3-0";
export var right = "_q3-4";
export var sliderOverflow = "_q3-7";